// ConfirmationModal.tsx
import React from "react";

interface ConfirmationModalProps {
  show: boolean;
  onDismiss: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ show, onDismiss }) => {
  if (!show) return null;

  return (
    <div style={modalOverlayStyle} role="dialog" aria-modal="true">
      <div style={modalDialogStyle}>
        <h2 className="govuk-heading-m">Saved Successfully</h2>
        <p className="govuk-body">Your reply or form was saved successfully.</p>
        <button className="govuk-button" onClick={onDismiss}>
          OK
        </button>
      </div>
    </div>
  );
};

const modalOverlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalDialogStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  padding: "1rem",
  borderRadius: "4px",
  maxWidth: "600px",
  width: "80%",
};

export default ConfirmationModal;
